export default "__VITE_ASSET__Bgpcum9R__"